export const NAOUNS_DAO_ACCOUNT_ID =
  "eip155:1:0xE087F94c3081e1832dC7a22B48c6f2b5fAaE579B"
